import * as yup from "yup";
import type { Asserts } from "yup";

// Response from /countries validation

const countrySchema = yup.object().shape({
  code: yup.string(),
  title: yup.string(),
  default: yup.boolean(),
});

const countriesSchema = yup.array().of(countrySchema);

export type TCountriesResponse = Asserts<typeof countriesSchema>;

const validateCountriesResponse = (response: any): TCountriesResponse => countriesSchema.validateSync(response);

export default validateCountriesResponse;
